export default "__VITE_PUBLIC_ASSET__66bcbf82__"